import {makeAutoObservable, observable, runInAction} from 'mobx';

import type {CourseExpandedCommon} from '../../../../api/course';
import type {WithBusyManager} from '../../../../utils/store';

import {courseFetchListPublic} from '../../../../services/entity-action/course/course.fetch-list-public';
import {AsyncBusyManager} from '../../../../utils/store';

type Config = {
  coachId: string;
  disableAutoFetch?: boolean;
  programId: string;
};

type ReasonKey = 'fetch';

export class PublicGroupCoursesStore implements WithBusyManager<ReasonKey> {
  busy = new AsyncBusyManager<ReasonKey>();
  courses: CourseExpandedCommon[] = [];

  constructor(private readonly config: Config) {
    this.busy.observe(this, {
      fetch: 'fetch',
    });

    makeAutoObservable(
      this,
      {
        courses: observable.shallow,
      },
      {autoBind: true},
    );

    if (!config.disableAutoFetch) {
      this.fetch();
    }
  }

  get isEmpty() {
    return this.courses.length === 0;
  }

  get isFetching() {
    return this.busy.getReason('fetch');
  }

  async fetch() {
    const courses = await courseFetchListPublic({
      coachId: this.config.coachId,
      programId: this.config.programId,
    });

    runInAction(() => {
      this.courses = courses;
    });
  }
}
